import { auth } from '../firebase';

const HINT_API_URL = (process.env.REACT_APP_HINT_API_URL || 'http://localhost:8787').replace(
  /\/$/,
  ''
);

export function problemIdFromPath(pathname) {
  const match = pathname.match(/^\/problems\/([^/]+)$/);
  return match ? match[1] : undefined;
}

export async function requestHint({
  message,
  problemId,
  workspaceMode,
  editorCode,
  simulatorCode,
  simulatorState,
  history,
}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Sign in to ask for a hint.');
  }

  const token = await user.getIdToken();
  let response;
  try {
    response = await fetch(`${HINT_API_URL}/hint`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        message,
        ...(problemId ? { problemId } : {}),
        ...(workspaceMode ? { workspaceMode } : {}),
        ...(editorCode ? { editorCode } : {}),
        ...(simulatorCode ? { simulatorCode } : {}),
        ...(simulatorState ? { simulatorState } : {}),
        ...(history?.length ? { history } : {}),
      }),
    });
  } catch {
    throw new Error(
      `Cannot reach the hint service at ${HINT_API_URL}. Start it with npm run dev in services/hint-rag.`
    );
  }

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok) {
    throw new Error(data.error || 'Could not get a hint right now.');
  }
  if (typeof data.hint !== 'string' || !data.hint.trim()) {
    throw new Error('Could not get a hint right now.');
  }
  return data.hint.trim();
}
